import React, { useContext } from 'react';
import {
  type Locale,
  type LoginLink,
} from './types'
import { IdentityServerReloginState } from "./types";

export type ParticipantLoginConfiguration = {
  availableLocales: Locale[];
  cookies: any;
  externalLoginLinks: LoginLink[];
  lastLoginLink: LoginLink;
  hasIdentityServerLogin: boolean;
  lastIdp: string;
  nativeAppRedirectUrl: string;
  productName: string;
  reloginState: string;
  sessionCookieName: string;
  translate: any;
}

type Action =
  | { type: 'UPDATE_CONFIGURATION'; payload: Partial<ParticipantLoginConfiguration> }

export const defaultParticipantLoginConfiguration: ParticipantLoginConfiguration = {
  availableLocales: [],
  cookies: null,
  externalLoginLinks: [],
  lastLoginLink: { Name: "Identity Provider" },
  hasIdentityServerLogin: false,
  lastIdp: '',
  productName: '',
  nativeAppRedirectUrl: '',
  reloginState: IdentityServerReloginState.None,
  sessionCookieName: '',
  translate: null,
}

export function reducer(configuration: ParticipantLoginConfiguration, action: Action): ParticipantLoginConfiguration {
  switch (action.type) {
    case 'UPDATE_CONFIGURATION':
      return { ...configuration, ...action.payload }
    default:
      return configuration
  }
}

export const AuthenticationConfigurationContext = React.createContext<ParticipantLoginConfiguration>(defaultParticipantLoginConfiguration);
export const AuthenticationConfigurationDispatchContext = React.createContext<React.Dispatch<Action>>(() => { });

export const useAuthenticationConfiguration = () => useContext(AuthenticationConfigurationContext);

export const useConfiguration = () => {
  const configuration = useAuthenticationConfiguration();

  return {
    configuration,
  }
}